import { Message } from 'src/types';

export type MessageOrChannelEntry =
  | (Message & { type: 'message' })
  | {
      type: 'notification';
      id: string;
      author: string | null | undefined;
      createdAt: string;
      isReporter: boolean;
      value: string;
      deletedAt?: string | null;
    };
[];

export const getCurrentMessageTimestamp = (
  index: number,
  array: MessageOrChannelEntry[],
) => {
  return array[index].createdAt;
};

export const getPreviousMessageTimestamp = (
  index: number,
  array: MessageOrChannelEntry[],
) => {
  return index > 0 ? array[index - 1].createdAt : 'invalid-date';
};

export const getNextMessageTimestamp = (
  index: number,
  array: MessageOrChannelEntry[],
) => {
  if (index < array.length - 1) {
    return (
      array[index + 1].deletedAt ?? array[index + 1].createdAt ?? 'invalid-date'
    );
  }
  return 'invalid-date';
};

export const checkIsSameAuthor = (
  index: number,
  array: MessageOrChannelEntry[],
) => {
  return index < array.length - 1
    ? array[index].author === array[index + 1].author
    : false;
};
